module.exports = __webpack_public_path__ + "img/zhbg@2x@2x.60935eaf.png";